import React, { Component } from "react";
import cn from "classnames";
import AbsoluteLayout from "../AbsoluteLayout";

const CLASS_NAME = "fct-border-layout";
class BorderLayout extends Component {
  render() {
    const { children, className, items, ...props } = this.props;
    return (
      <AbsoluteLayout className={cn(CLASS_NAME, className)} {...props}>
        {items.north ? (
          <AbsoluteLayout.Item
            key={items.north.key || "north"}
            left={0}
            right={0}
            top={0}
            height={items.north.height}
          >
            {items.north.el}
          </AbsoluteLayout.Item>
        ) : null}
        {items.south ? (
          <AbsoluteLayout.Item
            key={items.south.key || "south"}
            left={0}
            right={0}
            bottom={0}
            height={items.south.height}
          >
            {items.south.el}
          </AbsoluteLayout.Item>
        ) : null}
        {items.west ? (
          <AbsoluteLayout.Item
            key={items.west.key || "west"}
            left={0}
            top={items.north ? items.north.height : 0}
            bottom={items.south ? items.south.height : 0}
            width={items.west.width}
          >
            {items.west.el}
          </AbsoluteLayout.Item>
        ) : null}
        {items.east ? (
          <AbsoluteLayout.Item
            key={items.east.key || "east"}
            right={0}
            top={items.north ? items.north.height : 0}
            bottom={items.south ? items.south.height : 0}
            width={items.east.width}
          >
            {items.east.el}
          </AbsoluteLayout.Item>
        ) : null}
        {items.center ? (
          <AbsoluteLayout.Item
            key={items.center.key || "center"}
            left={items.west ? items.west.width : 0}
            right={items.east ? items.east.width : 0}
            top={items.north ? items.north.height : 0}
            bottom={items.south ? items.south.height : 0}
          >
            {items.center.el}
          </AbsoluteLayout.Item>
        ) : null}
      </AbsoluteLayout>
    );
  }
}
export default BorderLayout;



// WEBPACK FOOTER //
// ./layout/border/BorderLayout.js